import * as React from 'react';
import { Car16, Walk16 } from '@cian/ui-kit/icons';
import { InlineText2 } from '@cian/ui-kit/typography';

import { ETransportType } from '../../../../types/transportType';

import * as styles from './styles.css';

interface IFromUndergroundProps {
  transportType: ETransportType;
  timeTo: string;
}

export function FromUndergroundTime({ transportType, timeTo }: IFromUndergroundProps) {
  const Icon = transportType === ETransportType.Walk ? Walk16 : Car16;

  return (
    <div className={styles['distance']}>
      <div className={styles['icon']}>
        <Icon color={'gray_icons_100'} />
      </div>
      <InlineText2 color={'gray60_100'}>{timeTo}</InlineText2>
    </div>
  );
}
